import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { notification } from 'antd';
import { AUTH_REFRESH_TOKEN, AUTH_TOKEN, AUTH_CONFIRM_EMAIL_TOKEN } from 'constants/AuthConstant';

const unauthorizedCode = [401, 403]

const service = axios.create({
    baseURL: API_BASE_URL,
    timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'authorization'

// API Request interceptor
service.interceptors.request.use(config => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || localStorage.getItem(AUTH_CONFIRM_EMAIL_TOKEN) || null;

    if (jwtToken) {
        config.headers[TOKEN_PAYLOAD_KEY] = 'Bearer ' + jwtToken
    }

    if(config.data instanceof FormData) {
        config.headers['content-type'] = 'multipart/form-data'
    }

    return config
}, error => {
    // Do something with request error here
    notification.error({
        message: 'Error'
    })
    Promise.reject(error)
})


let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

// API respone interceptor
service.interceptors.response.use(
    response => response.data,
    async error => {
        let notificationParam = {
            message: ''
        };

        const originalRequest = error.config;
        
        if (error.response && (unauthorizedCode.includes(error.response.code) || unauthorizedCode.includes(error.response.status))) {
            if (!isRefreshing) {
                isRefreshing = true;

                const refreshToken = localStorage.getItem(AUTH_REFRESH_TOKEN);

                const refreshRequest = {
                    method: 'post',
                    url: `${API_BASE_URL}auth/refresh/${refreshToken}`,
                    headers: {}
                };

                try {
                    const { data: response } = await axios(refreshRequest);
                    localStorage.setItem(AUTH_TOKEN, response.accessToken);
                    localStorage.setItem(AUTH_REFRESH_TOKEN, response.refreshToken);

                    processQueue(null, response.accessToken);

                    originalRequest.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${response.accessToken}`;
                    return service.request(originalRequest);
                } catch (refreshError) {
                    processQueue(refreshError, null);

                    notificationParam.message = 'Falha na Autenticação';
                    notificationParam.description = 'Por favor, faça login novamente.';
                    localStorage.removeItem(AUTH_TOKEN);
                    localStorage.removeItem(AUTH_REFRESH_TOKEN);
                    store.dispatch(signOutSuccess());
                    notification.error(notificationParam);
                } finally {
                    isRefreshing = false;
                }
            }

            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
            }).then(token => {
                originalRequest.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${token}`;
                return service.request(originalRequest);
            }).catch(err => {
                return Promise.reject(err);
            });
        } else {
            notificationParam.message = error.response.data.message || 'Erro';
            notification.error(notificationParam);
        }

        return Promise.reject(error);
    }
);

export default service